import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

const Switch = ({ label, checked, onChange }) => {
  const handleClick = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);
  
  const handleKeyDown = useCallback((e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onChange(!checked);
    }
  }, [checked, onChange]);
  
  return (
    <div className="flex justify-between items-center w-full z-auto">
      <span className="text-primary">{label}</span>
      <div
        className={`relative w-[34px] h-[20px] rounded-full ${
          checked ?  'bg-accent' : 'bg-border-default'
        } cursor-pointer select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-accent`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="switch"
        aria-checked={checked}
        tabIndex={0}
      >
        <div
          className={`absolute left-[3px] top-[3px] w-[14px] h-[14px] rounded-full bg-page transform transition-transform duration-200 ${
            checked ? 'translate-x-[24px] bg-page' : 'translate-x-0 bg-panel'
          }`}
        >
        </div>
      </div>
    </div>
  );
};

Switch.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(Switch);
